import { Box, Flex, Text } from '@mantine/core';
import { GradientBorderedCard } from 'src/common/components/card/GradientBorderedCard';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  children: string;
  bg?: string;
  leftIcon?: React.ReactNode;
};

export function GradientBorderedInfoCard({ children, bg, leftIcon }: Props) {
  return (
    <GradientBorderedCard bg={bg}>
      <Flex direction="row" align={'center'}>
        {leftIcon && <Box mr="xxs">{leftIcon}</Box>}
        <Text size="sm" fw={FONT_WEIGHTS.semibold}>
          {children}
        </Text>
      </Flex>
    </GradientBorderedCard>
  );
}
